import $ from 'jquery';
import {deviceIsMinMd} from '../utilities/media-queries.mjs';
import Body from './Body.mjs';

// TODO: Accessibility - focus-trap, hide content-wrapper
const SELECTOR_TRIGGER_OPEN = '#quicknavigation-menu, .ef-job-postings-filter .btn';
const SELECTOR_TRIGGER_CLOSE = '[data-off-canvas-close]';
const CLASS_SLIDE_ANIMATION_COLLECTION = 'slideFromLeft slideFromRight slideToLeft slideToRight';
const canvasElements = [
  'off-canvas-menu',
  'content-canvas',
  'off-canvas-menu-job-postings-filter',
];
const menuOffCanvasIndex = 0;
const contentCanvasIndex = 1;
let currentOffCanvasIndex = 1;
const $contentCanvas = $('#' + canvasElements[contentCanvasIndex]);

export default class OffCanvas {
  constructor() {
    init.call(this);
  }
}

function init() {
  // Handle open
  $(document).on('click', SELECTOR_TRIGGER_OPEN, handleOffCanvasTrigger.bind(this));
  $(SELECTOR_TRIGGER_OPEN).removeClass('invisible');

  // Handle close
  $(document).on('click', SELECTOR_TRIGGER_CLOSE, handleOffCanvasCloseTrigger.bind(this));

  // Handle viewport change
  deviceIsMinMd.addListener(handleViewportChange.bind(this));

  // Handle page shadow click
  $('#page-shadow').on('click', handlePageShadowClick.bind(this));

  initLegacyMenuHandling.call(this);
}

function handleOffCanvasTrigger(event) {
  const $currentTrigger = $(event.currentTarget);
  const targetOffCanvasId = $currentTrigger.attr('aria-controls');
  const isSameAsTarget = (elementId) => elementId === targetOffCanvasId;
  const targetOffCanvasIndex = canvasElements.findIndex(isSameAsTarget);
  const $targetOffCanvas = $('#' + targetOffCanvasId);

  if (targetOffCanvasIndex === currentOffCanvasIndex) {
    closeOffCanvas.call(this, $targetOffCanvas, targetOffCanvasIndex, $currentTrigger);
    return;
  }

  openOffCanvas.call(this, $targetOffCanvas, targetOffCanvasIndex, $currentTrigger);
}

function handleOffCanvasCloseTrigger(event) {
  const $targetOffCanvas = $(event.currentTarget).closest('.off-canvas');
  const targetOffCanvasId = $targetOffCanvas.attr('id');
  const $offCanvasTrigger = $(`[aria-controls="${targetOffCanvasId}"]`);
  const isSameAsTarget = (elementId) => elementId === targetOffCanvasId;
  const targetOffCanvasIndex = canvasElements.findIndex(isSameAsTarget);

  closeOffCanvas.call(this, $targetOffCanvas, targetOffCanvasIndex, $offCanvasTrigger);
}

/**
 *
 * @param {MediaQueryListEvent} deviceIsMinMd
 */
function handleViewportChange(deviceIsMinMd) {
  if (deviceIsMinMd.matches) {
    // Restore content canvas position
    $contentCanvas.removeClass(CLASS_SLIDE_ANIMATION_COLLECTION);

    // Hide menu off-canvas when necessary
    const $menuOffCanvas = $('#' + canvasElements[menuOffCanvasIndex]);
    const menuOffCanvasId = $menuOffCanvas.attr('id');
    const $menuOffCanvasTrigger = $(`[aria-controls="${menuOffCanvasId}"]`);

    if (currentOffCanvasIndex === menuOffCanvasIndex) {
      // Update index
      currentOffCanvasIndex = contentCanvasIndex;

      Body.restoreBodyScrolling();

      $menuOffCanvasTrigger.removeClass('is-active');

      // Focus
      $menuOffCanvas.attr('aria-hidden', 'true');
      $('#anchor-top').focus();
    }

    // Hide every time in case store off-canvas was active
    $menuOffCanvas.removeClass(CLASS_SLIDE_ANIMATION_COLLECTION);
  }
}

function handlePageShadowClick() {
  const $targetOffCanvas = $('#' + canvasElements[currentOffCanvasIndex]);
  const targetOffCanvasId = $targetOffCanvas.attr('id');
  const $offCanvasTrigger = $(`[aria-controls="${targetOffCanvasId}"]`);

  closeOffCanvas.call(this, $targetOffCanvas, currentOffCanvasIndex, $offCanvasTrigger);
}

function openOffCanvas($targetCanvas, targetOffCanvasIndex, $trigger) {
  const $currentCanvas = $('#' + canvasElements[currentOffCanvasIndex]);
  const currentOffCanvasId = $currentCanvas.attr('id');
  const $currentOffCanvasTrigger = $(`[aria-controls="${currentOffCanvasId}"]`);

  let directionFrom;
  let directionTo;

  if (targetOffCanvasIndex < currentOffCanvasIndex) {
    // Open from left
    directionFrom = 'FromLeft';
    directionTo = 'ToRight';
  }
  if (targetOffCanvasIndex > currentOffCanvasIndex) {
    // Open from right
    directionFrom = 'FromRight';
    directionTo = 'ToLeft';
  }

  // Update index
  currentOffCanvasIndex = targetOffCanvasIndex;

  Body.preventBodyScrolling();

  // Animate
  if (deviceIsMinMd.matches === false) {
    $currentCanvas.removeClass(CLASS_SLIDE_ANIMATION_COLLECTION).addClass('slide' + directionTo);
  }
  $targetCanvas.removeClass(CLASS_SLIDE_ANIMATION_COLLECTION).addClass('slide' + directionFrom);

  $currentOffCanvasTrigger.removeClass('is-active');
  $trigger.addClass('is-active');
  $trigger.attr('aria-expanded', 'true');

  // Focus
  $currentCanvas.attr('aria-hidden', 'true');
  $targetCanvas.attr('aria-hidden', 'false');
  $targetCanvas.focus();
}

function closeOffCanvas($currentCanvas, currentCanvasIndex, $trigger) {
  let directionFrom;
  let directionTo;

  if (currentCanvasIndex < contentCanvasIndex) {
    // Close to left
    directionFrom = 'FromRight';
    directionTo = 'ToLeft';
  }
  if (currentCanvasIndex > contentCanvasIndex) {
    // Close to right
    directionFrom = 'FromLeft';
    directionTo = 'ToRight';
  }

  // Update index
  currentOffCanvasIndex = contentCanvasIndex;

  // Animate
  $currentCanvas.removeClass(CLASS_SLIDE_ANIMATION_COLLECTION).addClass('slide' + directionTo);
  if (deviceIsMinMd.matches === false) {
    $contentCanvas.removeClass(CLASS_SLIDE_ANIMATION_COLLECTION).addClass('slide' + directionFrom);
  }

  Body.restoreBodyScrolling();

  $trigger.removeClass('is-active');
  $trigger.attr('aria-expanded', 'false');

  // Focus
  $currentCanvas.attr('aria-hidden', 'true');
  $contentCanvas.attr('aria-hidden', 'false');
  $trigger.focus();

  $currentCanvas.trigger('closed.offcanvas');
}

function initLegacyMenuHandling() {
  // Close off-canvas menu, if a shortcut link for the same page is clicked
  $(document).on('click', '.nav-link-shortcut', (event) => {
    const $link = $(event.currentTarget);
    const linkPathName = $link.get(0).pathname;
    const currentPathName = window.location.pathname;

    if (linkPathName === currentPathName) {
      // Close off-canvas
      const $targetOffCanvas = $('#' + canvasElements[currentOffCanvasIndex]);
      const targetOffCanvasId = $targetOffCanvas.attr('id');
      const $offCanvasTrigger = $(`[aria-controls="${targetOffCanvasId}"]`);

      closeOffCanvas.call(this, $targetOffCanvas, currentOffCanvasIndex, $offCanvasTrigger);
    }
  });

  const initOffCanvasLevel = $('.js_offcanvas-next-sub.active').last().prev('.offcanvas-next-layer').data('next-level');
  if (initOffCanvasLevel > 0) {
    offcanvasLevelShow.call(this, initOffCanvasLevel);
  }

  $('.offcanvas-next-layer').on('click', function () {
    const $targetOffCanvasLevel = $($(this).data('next-target')),
      nextLevel = $(this).data('next-level'),
      previousLevel = nextLevel - 1;

    $targetOffCanvasLevel.addClass('active');
    offcanvasLevelHide(previousLevel);
    offcanvasLevelShow.call(self, nextLevel);
  });

  $(document).on('click', '.offcanvas-back', function () {
    const $currentOffCanvasLevel = $(this).parents('.js_offcanvas-next-sub').first(),
      previousLevel = $(this).data('prev-level'),
      currentLevel = previousLevel + 1;
    offcanvasLevelHide(currentLevel);
    offcanvasLevelShow.call(self, previousLevel);
    setTimeout(function () {
      $currentOffCanvasLevel.removeClass('active');
    }, 250);
    $('#panel-offcanvas-wrapper').animate({
      scrollTop: 0
    }, 1000);
  });

  function offcanvasLevelShow(level) {
    var $body = $('body');
    $body.addClass('offcanvas-level' + level + '-open');
  }

  function offcanvasLevelHide(level) {
    var $body = $('body');
    $body.removeClass('offcanvas-level' + level + '-open');
  }
}
